import { h } from 'preact';

import SkyItPanel from '../../../components/3-molecules/sky-it-panel/sky-it-panel';
import { parseImagesForPanels } from '../../../utils/parsers';

export const renderPanel = (data) => (
  <SkyItPanel
    hasBorder
    title={data.title}
    description={data.description}
    hasImageCentered={data.hasImageCentered}
    isReversed={data.isReversed}
    images={parseImagesForPanels(data.images)}
    ctaPrimaryLabel={data.ctaLabel}
    ctaPrimaryHref={data.ctaUrl}
  />
);
